// Table.js
import React from "react";
import Title from "./title";

const Table = (props) => {
  const {emptyMessage = "No hay registros"} = props;

  let content = (
    <table className="table table-component table-sm">
      <thead>
        <tr>
          {props.header.map((item, key) => {
            const isObject = typeof item === "object" && item !== null;
            const label = isObject ? item.label : item;
            const isString = typeof label === "string";
            const isLast = key === props.header.length - 1;
            const isActions =
              isString && label.toLowerCase().includes("acciones");

            const defaultAlign = isLast || isActions ? "center" : "left";
            const textAlign =
              isObject && item.align ? item.align : defaultAlign;

            const lines =
              isString && label.includes("\n") ? label.split("\n") : [label];

            return (
              <th key={key} style={{textAlign}}>
                {lines.map((line, index) => (
                  <div key={index} style={{textAlign}}>
                    {line}
                  </div>
                ))}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>{props.children}</tbody>
    </table>
  );

  if (!props.data || props.data === 0) {
    content = <h2 className="no-table-data">{emptyMessage}</h2>;
  }

  return (
    <div className={`table-container ${props?.className || ""}`}>
      <Title right={props.right} name={props.title} />
      <div className="table-responsive">{content}</div>
    </div>
  );
};

export default Table;
